import {Button, Card} from 'antd';
import {Auth} from 'aws-amplify';
import {BottomActions, Spacer} from 'components';
import {usePolicyToUpdate} from 'hooks/usePolicyToUpdate';
import {useUserContext} from 'hooks/useUserContext';
import {getPolicies, getPolicyUrl} from 'lib/policyUtils';
import React, {useEffect, useMemo, useState} from 'react';
import styled from 'styled-components';

type Props = {};

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  border-radius: 2px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  margin: 0 auto;
`;

const PolicyCard = styled(Card)`
  flex: 1;
`;

export const PolicyUpdate: React.FC<Props> = () => {
  const {setCurrentUser} = useUserContext();
  const policies = useMemo(() => getPolicies(), []);
  const policyType = usePolicyToUpdate();
  const [isLoading, setLoading] = useState(false);
  const [policyUrl, setPolicyUrl] = useState('');

  const policy = policies[policyType!];

  useEffect(() => {
    const fetchPolicy = async () => {
      const url = await getPolicyUrl(policy.doc);
      setPolicyUrl(url);
    };
    void fetchPolicy();
  }, [policy?.doc]);

  if (!policy) return null;

  const handleAcceptPolicy = async () => {
    setLoading(true);
    let currentUser = await Auth.currentAuthenticatedUser();
    const url = new URL(policyUrl);
    await Auth.updateUserAttributes(currentUser, {
      [policy.cognitoDateField]: new Date().toISOString(),
      [policy.cognitoDocField]: `${url.origin}${url.pathname}`
    });
    currentUser = await Auth.currentAuthenticatedUser({bypassCache: true});
    setCurrentUser(currentUser);
    setLoading(false);
  };

  return (
    <Container>
      <h2>Please accept updated {policy.title} to continue</h2>
      <PolicyCard
        size="small"
        bodyStyle={{backgroundColor: '#f7fafc', padding: 0, overflow: 'hidden', height: '100%'}}
        headStyle={{marginBottom: 0}}>
        <IFrame src={policyUrl} />
      </PolicyCard>
      <BottomActions>
        <Spacer />
        <Button type="primary" onClick={handleAcceptPolicy} loading={isLoading}>
          Accept and continue
        </Button>
      </BottomActions>
    </Container>
  );
};
